












import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import ThemeService from '@/_shared/services/theme.service';

@Component
export default class FilterIcon extends Vue {
  @Prop({ type: String, default: ThemeService.getStyleVariable('colors-primary') })
  public hexColor!: string;
}
